import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('@app/layout/layout.module').then((m) => m.LayoutModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('@app/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    // Приём приглашения по ссылке из письма (без layout). Авторизацию проверяет сам компонент.
    path: 'access/accept',
    loadChildren: () =>
      import('@app/invitation-accept/invitation-accept.module').then((m) => m.InvitationAcceptModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always',
      scrollOffset: [0, 0],
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
